const emitir_relatorio_de_alunos_com_informacoes_pendentes = [
  {
    path: "/emitir-relatorio-de-alunos-com-informacoes-pendentes",
    name: "emitir_relatorio_de_alunos_com_informacoes_pendentes",
    meta: {
      breadCrumb:
        "Censo Escolar - Relatório de Acompanhamento do Censo Escolar",
      allowedPermissions: ["relatorios_aluno_informacoes_pendentes"],
    },
    component: () =>
      import(
        "@/views/EmitirRelatorioDeAlunosComInformacoesPendentes/EmitirRelatorioDeAlunosComInformacoesPendentes.vue"
      ),
  },
];

export { emitir_relatorio_de_alunos_com_informacoes_pendentes };
